import AdjustItems from './adjustedItems';
import AdjustItemHeader from './adjustItemsHeader';

const AdjustedItems = ({ Texts, adjustedItems, getUpdatedData }: any) => {
  return (
    <section className="w-full rounded-md border border-foggyGray px-5 py-4 shadow-lg">
      <h2 className="mb-4 text-lg font-bold">{Texts.adjustedLineItems}</h2>

      <section>
        <AdjustItemHeader Texts={Texts} />

        {adjustedItems?.map((LineItem: any) => (
          <section key={LineItem?.lineSequence}>
            <AdjustItems Texts={Texts} item={LineItem} getUpdatedData={getUpdatedData} />
          </section>
        ))}

        {adjustedItems?.length === 0 ? Texts.noRecordsFound : ''}
      </section>
    </section>
  );
};

export default AdjustedItems;
